export default "__VITE_ASSET__HtJloXR9__"